<template>
    <div>
      <!-- Titulo -->
        <div
        style="position: absolute; top: -70px; left: 50%; transform: translateX(-50%); color: black; font-size: 17px; font-weight: bold;"
        >
        {{input.customized.name}}
      </div>
    
      <!-- Bombas -->
      <canvas
        @click="showBomb = true"
        ref="motorCanvas"
        width="100" 
        height="100" 
        style="position: absolute; width: 100%; height: 80%; cursor: pointer"
      ></canvas>
  
      <!-- Mostrar bombas -->
      <v-dialog v-if="!editing" v-model="showBomb" max-width="500">
        <v-card
          class="custom-card bomb-card"
          style="height: inherit"
        >
          <v-card-title
            class="d-flex flex-column align-start pt-2 pb-2"
            :style="{ backgroundColor: bombFailureAlarmValue ? `red` : `#e3eef9` }"
          >
            <div class="table-title">
              {{ input.customized.name }}
            </div>
          </v-card-title>
  
          <v-card-text class="mt-2 pt-1">
            <v-row>
              <v-col cols="4">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(true)"
                >
                  MARCHA
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(false)"
                >
                  PARO
                </v-btn>
              </v-col>
              <v-col cols="4">
                <div class="centered-div">
                  <v-icon
                    class="mt-0"
                    medium
                    :color="continuousRunningValue ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapState } from "vuex";

  import MotorApagadoImageSrc from "@/plugins/bomb_canvas/assets/motorApagado.png";
  import MotorEncendidoImageSrc from "@/plugins/bomb_canvas/assets/motorEncendido.png";
  import MotorAlarmaImageSrc from "@/plugins/bomb_canvas/assets/motorAlarma.png"

  import MoveableComponent from "@/components/generic/MoveableComponent.vue";
  export default {
    name: "koiote-bomb-canvas-quesos",
  
    props: {
      input: Object,
    },
    components: {
      MoveableComponent,
    },
    data() {
      return {
        motorApagadoImage: null,
        motorEncendidoImage: null,
        motorAlarmaImage: null,
        showBomb: false,
        labelCanvasStyle: {
          position: "absolute",
          height: "40%",
          top: "10%",
          left: "20%",
          zIndex: 2,
          background: "rgba(255, 255, 255, 0.6)",
          border: "1px solid black",
          width: "0px",
          cursor: "pointer"
        }
      };
    },
  
    computed: {
      ...mapState(["editing"]),
  
      vartable() {
        return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable;
      },
      allImagesLoaded() {
        return this.motorApagadoImage != null && this.motorEncendidoImage != null;
      },
      //Bombas
      bombFailureAlarmValue() {
        return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_bomb_failure_alarm)?.value;
      },
      continuousRunningValue() {
        return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_continuous_running)
          ?.value;
      },
    },
  
    methods: {
      ...mapGetters(["actualPage"]),
  
      // Bombas ---------------------------------------------------------------------------
      async makeMotorBomba() {
        const canvas = this.$refs.motorCanvas;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        let img = null;
        if (this.bombFailureAlarmValue) img = this.motorAlarmaImage;
        else img = this.continuousRunningValue ? this.motorEncendidoImage : this.motorApagadoImage;
        if(canvas && img) {
          await ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        }
      },
  
      loadMotorApagadoImage() {
        const img = new Image();
        img.src = MotorApagadoImageSrc;
        img.onload = () => (this.motorApagadoImage = img);
      },
  
      loadMotorEncendidoImage() {
        const img = new Image();
        img.src = MotorEncendidoImageSrc;
        img.onload = () => (this.motorEncendidoImage = img);
      },

      loadMotorAlarmaImage() {
        const img = new Image();
        img.src = MotorAlarmaImageSrc;
        img.onload = () => (this.motorAlarmaImage = img);
      },
  
      setRunOrderValue(value) {
        const variableToChange = this.vartable.find(
          (v) => v.formatted_address == this.input.customized.variable_run_order
        );
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        });
      },
  
      adaptFormat(item) {
        return (() => {
          switch (item.type) {
            case "BIT":
              return item.value;
            case "ENTERO":
            case "REAL":
              return Number(item.value);
            default:
              return "";
          }
        })();
      },
  
      setCanvasWidth() {
        const bombCanvas = this.$refs.motorCanvas;
        if (bombCanvas) {
          console.log("Si que esta tankcanvas")
          const bombCanvasWidth = bombCanvas.offsetWidth * 0.63;
          this.labelCanvasStyle.width = `${bombCanvasWidth}px`;
        }else {
          console.log("no esta tankcanvas")
        }
      }
    },
  
    mounted() {
      this.loadMotorEncendidoImage();
      this.loadMotorApagadoImage();
      this.loadMotorAlarmaImage();
      this.setCanvasWidth();
      window.addEventListener("resize", this.setCanvasWidth);
    },
  
    beforeDestroy() {
      window.removeEventListener("resize", this.setCanvasWidth);
    },
  
    watch: {
  
      continuousRunningValue() {
        this.makeMotorBomba();
      },
  
      allImagesLoaded(value) {
        if (value) {
          this.makeMotorBomba();
        }
      },
  
      input: {
        handler() {
          this.makeMotorBomba();
        },
        deep: true,
      },
    },
  };
  </script>
